import React from "react";
import notify from "./notify";
import cn from "../../utils/cn";

const CopyContent = ({
  value,
  className,
  children,
  id = 1,
  // Default message to show when the address is copied to clipboard
  message = "The address was copied to your clipboard!",
}) => {
  const handleCopy = async (e) => {
    e.stopPropagation();
    var copyTextarea = document.querySelector(`.copy-textarea-${id}`);
    copyTextarea.focus();
    copyTextarea.select();

    try {
      // Attempt to copy the link to clipboard
      let successfulCopied = document.execCommand("copy");

      if (successfulCopied) {
        notify(message, "success");
      } else {
        // If copy command fails, fallback to using navigator.clipboard
        await navigator.clipboard.writeText(value);
        notify(message, "success");
      }
    } catch (err) {}
  };
  return (
    <div onClick={handleCopy} className="relative">
      <span className={cn("cursor-pointer", className)}>{children}</span>

      <textarea
        readOnly
        className={` h-1 w-1 opacity-0 rounded-md flex justify-center items-center appearance-none focus:border-none focus-within:outline-none border-none outline-none resize-none overflow-hidden select-none copy-textarea-${id}`}
      >
        {value}
      </textarea>
    </div>
  );
};

export default CopyContent;
